const INITIAL_STATE = {
  articles: [],
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SEARCH_ARTICLE_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'SEARCH_ARTICLE_SUCCESS':
      return {
        ...state,
        loading: false,
        articles: action.payload,
      };
    case 'SEARCH_ARTICLE_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'LOGOUT':
      return INITIAL_STATE;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/search.js